// @/components/ui/MetadataForm.tsx

import React from 'react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { MetadataField } from '@/types/diagram';

interface MetadataFormProps {
  fields: MetadataField[];
  values: { [key: string]: any };
  onChange: (values: { [key: string]: any }) => void;
}

const MetadataForm: React.FC<MetadataFormProps> = ({ fields, values, onChange }) => {
  const handleFieldChange = (name: string, value: any) => {
    onChange({
      ...values,
      [name]: value
    });
  };

  return (
    <div className="space-y-4">
      {fields.map((field) => (
        <div key={field.name} className="space-y-2">
          <label className="block text-sm font-medium text-text-primary">
            {field.label}
            {field.required && <span className="text-error ml-1">*</span>}
          </label>

          {field.type === 'select' ? (
            <Select
              value={values[field.name] || ''}
              onValueChange={(value) => handleFieldChange(field.name, value)}
            >
              <SelectTrigger className="w-full bg-surface-input text-text-primary border-surface-border">
                <SelectValue placeholder={`Select ${field.label.toLowerCase()}`} />
              </SelectTrigger>
              <SelectContent className="bg-surface-elevated border-surface-border">
                {field.options?.map((option) => (
                  <SelectItem
                    key={option.value}
                    value={option.value}
                    className="text-text-primary hover:bg-surface-hover"
                  >
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : (
            <Input
              type="text"
              value={values[field.name] || ''}
              onChange={(e) => handleFieldChange(field.name, e.target.value)}
              className="w-full bg-surface-input text-text-primary border-surface-border"
              placeholder={`Enter ${field.label.toLowerCase()}`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default MetadataForm;